import { Injectable } from "@angular/core";
import { BehaviorSubject, map, tap, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { ActionResult, EventItem, WspayConfirmation, WspayForm, WspayFormRequest } from "@model";
import { EnvironmentService } from "./environment.service";


/// https://docs.wspay.info/wspayform
@Injectable({ providedIn: 'root' })
export class WsPayService {
  private _currentWspayConfirmation = new BehaviorSubject<WspayConfirmation | undefined>(undefined);

  get currentWspayConfirmation() {
    return this._currentWspayConfirmation;
  }

  constructor(
    private loaderService: LoaderService,
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  fetchWsPayForm(wsFormRequest: WspayFormRequest, onSuccess: (redirectUrl: string) => void, onError: () => void) {
    this.loaderService.startLoading();
    this.http.post<ActionResult<WspayForm>>(this.environmentService.getApiUrl() + "/api/public/payment/wspay/form", wsFormRequest)
      .pipe(tap(() => this.loaderService.dismissLoading()))
      .subscribe(
        response => onSuccess(response.result?.PaymentFormUrl ?? ''),
        () => onError()
      );
  }

  fetchPaymentResult(token: string): Observable<WspayConfirmation | null> {
    return this.http.get<ActionResult<WspayConfirmation>>(
        `${this.environmentService.getApiUrl()}/api/public/payment/result/${token}`
    ).pipe(
        map(actionResult => {
          const result = actionResult.result;
          if (result) {
            result.event = {
              name: result.eventName,
              nameEng: result.eventNameEng,
              nameIta: result.eventNameIta,
              nameSlo: result.eventNameSlo,
              nameSr: result.eventNameSr,
              defaultLanguage: result.eventDefaultLang,
              start: result.eventStart
            } as EventItem;
          }
          return result ?? null;
        })
    );
  }
}
